import React, {  useState, useRef, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useNavigate, useLocation ,NavLink} from 'react-router-dom';
import Home from './Home';
import About from './About';
import Collection from './Collection';
import Contact from './Contact';
import './App.css';
import Feedback from './feedback';
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
function AppContent() {
  const [scrollPending, setScrollPending] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const footerRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();

  const handleLinkClick = () => {
    setMenuOpen(false);
  };



  const handleContactClick = () => {
  setMenuOpen(false);
  navigate('/contact');
};

 const [showFeedback, setShowFeedback] = useState(false);

  const openPopup = () => setShowFeedback(true);
  const closePopup = () => setShowFeedback(false);
  return (
    
      <div className="App">
        <header className="navbar">
          <div className="logo">
            <Link to="/" onClick={handleLinkClick}>
              <img src="/images/Frame 38.png" alt="Aman Chikan Handicraft" />
            </Link>
          </div>

          <div
            className={`menu-toggle ${menuOpen ? 'active' : ''}`}
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle menu"
          >
            <span className="hamburger-line"></span>
            <span className="hamburger-line"></span>
            <span className="hamburger-line"></span>
          </div>

          <nav className={`nav-links ${menuOpen ? 'active' : ''}`}>
            <NavLink to="/" onClick={handleLinkClick}>HOME</NavLink>
            <NavLink to="/about" onClick={handleLinkClick}>ABOUT US</NavLink>
            <NavLink to="/collection" onClick={handleLinkClick}>COLLECTION</NavLink>
            <NavLink to="/contact" onClick={handleLinkClick}>CONTACT</NavLink>
          </nav>

          <div className="actions">
           {/* <button className="contact-btn" onClick={handleContactClick}>
            CONTACT US
          </button> */}
          </div>
        </header>

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/collection" element={<Collection />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/feedback" element={<Feedback />} />

        </Routes>

        {/* ✅ Footer starts here */}
        <footer  ref={footerRef}  className="footer">
          <div className="footer-container">
            <div className="footer-column">
              <h4>Quick Links</h4>
              <ul>
                <li><Link to="/">Home</Link></li>
                <li><Link to="/about">About Us</Link></li>
                <li><Link to="/collection">Shop Collection</Link></li>
                <li><Link to="/contact">Contact Us</Link></li>
                <li><Link to="/feedback">Feedback</Link></li>
              

              </ul>
            </div>

            <div className="footer-column">
              <h4>Popular Categories</h4>
              <ul>
                <li><Link to="/collection">Kurtis Sets</Link></li>
                <li><Link to="/collection">Sarees</Link></li>
              </ul>
            </div>

            <div className="footer-column">
              <h4>Contact Us</h4>
              <p><img src="/images/Email.png" alt="email" /> amanchikankari17@gmail.com</p>
              <p><img src="/images/Phone.png" alt="phone" /> +91-7392-020965</p>
              <p><img src="/images/Spacer Icon Wrapper.png" alt="address" /> 12, Tulsi Theatre, Hazratganj, 226001</p>
            </div>

            <div className="footer-column">
              <div className="logo">
                <img src="/images/Frame 38.png" alt="Aman Chikan Handicraft" />
              </div>
              <p>Authentic Chikankari, Handcrafted with Love. Timeless whites to vibrant florals — shop pure tradition today.</p>
              <h4>FOLLOW US</h4>
              <div className="social-icons">
                <a href="https://wa.me/7392020965" target="_blank" rel="noopener noreferrer">
                  <img src="/images/Group 17795.png" alt="WhatsApp" />
                </a>
                <a href="https://www.instagram.com/amanchikanhandicraft?igsh=NDY1dDlubW94ZGNp" target="_blank" rel="noopener noreferrer">
                  <img src="/images/Instagram.png" alt="Instagram" />
                </a>
                <a href="https://youtube.com/@amanchickanhandicraft?si=DIfusMyBm_wZ06IC" target="_blank" rel="noopener noreferrer">
                  <img src="/images/Youtube.png" alt="YouTube" />
                </a>
              </div>
              <div className="app-links">
                <a href="https://play.google.com/store"><img src="/images/Google Play.png" alt="Google Play" /></a>
                <a href="https://apps.apple.com/app/app-name/idapp-id"><img src="/images/App Store.png" alt="App Store" /></a>
              </div>
            </div>
          </div>

          <div className="footer-bottom">
            <p className="left">Copyright &copy; 2025 Aman Chikan Handicraft</p>
            <p className="right">
              All Rights Reserved |
              <a href="#">Terms and Conditions</a> |
              <a href="#">Privacy Policy</a>
            </p>
          </div>
        </footer>
        {/* ✅ Footer ends here */}
      </div>
    
  );
}
function App() {
  return (
    <Router>
      <ScrollToTop />
      <AppContent />
    </Router>
  );
}
export default App;
